/* src/app/components/doc-viewer-new/doc-viewer-right-panel/doc-viewer-coding-tab/doc-viewer-coding-tab.component.scss */
.reviewed-by-row {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.reviewed-by-node {
  margin-left: 4px;
  margin-right: 8px;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .reviewed-by-node {
  color: rgb(255, 193, 7);
}
.same-as-last-button {
  background: #FFF;
  border: 1px solid rgba(63, 81, 181, 0.7490196078);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 2px 2px;
}
:host-context(.dark-theme) .same-as-last-button {
  color: #fff;
  background: #000;
  border: 1px solid rgba(255, 193, 7, 0.7490196078);
}
.icon {
  color: #3949AB;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #737373;
  --fa-secondary-opacity: 1 ;
}
.add-coding-field-button {
  background-color: #E4E4E4;
  color: #000;
}
:host-context(.dark-theme) .add-coding-field-button {
  background-color: #000;
  color: #FFC107;
}
/*# sourceMappingURL=doc-viewer-coding-tab.component.css.map */
